import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { from } from 'rxjs/observable/from';
import { tap, switchMap } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  token : any;
  constructor(private authService: AuthService, private _alertService: AlertService,) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.token = this.authService.getTokenUser();
    

    if (!request.headers.get('Authorization')){

      if (this.token != 0 && this.token != undefined ) {
        request = request.clone({
          withCredentials: true,
          setHeaders: {
            Authorization: `token ${this.token}`
          }
        });
      }else{
        
        if(this.authService.currentUserValue){
          request = request.clone({
            withCredentials: true,
            setHeaders: {
              Authorization: `token ${this.authService.currentUserValue.token}`
            }
          });
        }else{
          request = request.clone({
            withCredentials: true,
            setHeaders: {
              Authorization: `token ${this.token}`
            }
          });
        }
        
        
      }
    }
    
    
    //return next.handle(request);
    return next.handle(request).pipe(tap(evt => {
      if (evt instanceof HttpResponse) {
        
        if (evt.body.code == 33) {
          //this.authenticationService.redireccionarLogin(evt.body.msg);
        }

      }
      
    }
      ,
      err => {
        if (err.status == 401) {//sin permiso
          let msg = "Token invalido o vencido, a continuación la aplicación cerrará la sesión";

          this._alertService.openConfirmsSwal({
            text: msg,
            type: 'error',
            confirmButtonText: 'Aceptar',
            handlerConfirm: () => {
              this.authService.removeToken()
            },
          });

        } 
      })
    )
  }

}


// WEBPACK FOOTER //
// ./src/app/core/interceptors/token.interceptor.ts